<template>
    <section class="wizard" >
        <header>
            <slot name="header"></slot>
        </header>
        <main class="wizard-steps" :style="{minHeight: minHeightSteps + 'px'}">
            <Transition :name="animation" mode="out-in">
                <slot name="steps"></slot>
            </Transition>
        </main>
        <footer class="mt-3">
            <slot name="footer"></slot>
        </footer>
    </section>
</template>

<script>
import {paginationScrollTo} from "../helpers/helpers";
import {mapMutations} from "vuex";

export default {
    name: "Wizard",
    data() {
        return {
            animation: 'slide'
        }
    },
    props: {
        stepsCount: {
            type: Number,
            required: true,
        },
        minHeightSteps: {
            type: Number,
            default: 300
        },
        disableNext: {
            type: Boolean,
            default: false
        },
        currentIndex: {
            type: Number,
            required: true
        }
    },
    methods: {

    },
    watch: {
        currentIndex() {
            paginationScrollTo('.wizard')
        }
    }
}
</script>

<style lang="scss" scoped>
.wizard {
    overflow: hidden;
    &-steps {
        position: relative;
    }

    footer {
        text-align: right;
        padding: 15px 0;

        button:not(:last-child) {
            margin-right: 10px;
        }
    }
}

.slide-leave-active,
.slide-enter-active {
    transition: 0.2s ;
}
.slide-enter {
    transform: translate(100%, 0);
}
.slide-leave-to {
    transform: translate(-100%, 0);
}

.slide-back-leave-active,
.slide-back-enter-active {
    transition: 0.2s ;
}
.slide-back-enter {
    transform: translate(-100%, 0);
}
.slide-back-leave-to {
    transform: translate(100%, 0);
}





</style>
